import z from "zod";
import { REGEX_PADDED_INCOME } from "../../../const/regexes";
import { ANNUAL_INCOME_INVALID, MAX_ANNUAL_INCOME, } from "../../../schemas/const/errorMessages";
var ENTER_INCOME_REQUIRED = {
    message: "incomeCapture.error.message",
};
export var INCOME_UPDATE_SCHEMA = z.object({
    income: z
        .string()
        .min(1, ENTER_INCOME_REQUIRED)
        .max(9, MAX_ANNUAL_INCOME)
        .regex(REGEX_PADDED_INCOME, ANNUAL_INCOME_INVALID),
});
